// Components
import { Typography } from '@archieai/ui';
import { MagicCard } from '../MagicCard/MagicCard';

// Graphics
import { CEOsGraphic } from '../MagicCard/graphics/CEOsGraphic';
import { CFOsGraphic } from '../MagicCard/graphics/CFOsGraphic';
import { COOsGraphic } from '../MagicCard/graphics/COOsGraphic';
import { CDOsGraphic } from '../MagicCard/graphics/CDOsGraphic';

// Types
type PersonaConfig = {
  label: string;
  title: string;
  description: string;
  variant: 'orange' | 'lightBlue' | 'darkBlue' | 'teal';
  href: string;
  Graphic: React.ComponentType;
};

const PERSONAS: PersonaConfig[] = [
  {
    label: 'CEOs & Managing Partners',
    title: 'CEOs and Managing Partners',
    description:
      'Drive growth and improve margins without adding headcount or breaking what already works.',
    variant: 'orange',
    href: '/ceos',
    Graphic: CEOsGraphic,
  },
  {
    label: 'CFOs & Finance Teams',
    title: 'CFOs and Internal Finance Teams',
    description:
      'Maximize operational efficiency and accelerate financial reporting with proven automation playbooks.',
    variant: 'lightBlue',
    href: '/cfos',
    Graphic: CFOsGraphic,
  },
  {
    label: 'COOs',
    title: 'COOs',
    description:
      'Design and implement operational strategies that scale with your ambition.',
    variant: 'darkBlue',
    href: '/coos',
    Graphic: COOsGraphic,
  },
  {
    label: 'CDOs & Transformation',
    title: 'CDOs and Heads of Transformation',
    description:
      'Build a self-sustaining transformation engine that thrives independently of your daily involvement.',
    variant: 'teal',
    href: '/cdos',
    Graphic: CDOsGraphic,
  },
];

export const WhyHireSection = () => {
  return (
    <section
      id="who-are-you"
      className="flex flex-col items-center gap-[var(--spacing-48)] px-[var(--spacing-24)] py-[var(--spacing-64)] w-full max-w-[1224px] max-md:px-[var(--spacing-16)] max-md:py-[var(--spacing-48)] max-md:gap-[var(--spacing-32)]"
    >
      <Typography
        as="h2"
        variant="h1"
        className="text-blue-1000 text-center max-w-[1153px]"
      >
        Why Would You Hire Archie?
      </Typography>

      <div className="grid grid-cols-2 gap-[var(--spacing-24)] w-full max-w-[1016px] max-sm:grid-cols-1 max-sm:justify-items-center">
        {PERSONAS.map((persona) => (
          <MagicCard
            key={persona.title}
            label={persona.label}
            title={persona.title}
            description={persona.description}
            variant={persona.variant}
            href={persona.href}
            Graphic={persona.Graphic}
          />
        ))}
      </div>
    </section>
  );
};
